import { Link } from "react-router-dom";
import { Badge, Card, CardBody, Col, Nav, NavItem } from "reactstrap";
import { Btn, H3, Image, P } from "../../../AbstractElements";
import { EmailFilter, Inbox, MARKJENCOEMAIL, MarkJenco, NewMail } from "../../../Constant";
import { dynamicImage } from "../../../Service/DynamicImage";
import DynamicEmailSideBar from "./DynamicEmailSideBar";
import { useAppDispatch, useAppSelector } from "../../../Redux-Toolkit/Hooks";
import { setOpenFilter } from "../../../Redux-Toolkit/Reducers/EmailSlice";

export const MailSideBar = () => {
  const {openFilter} = useAppSelector((state)=>state.email)
  const dispatch = useAppDispatch()
  return (
    <Col xl="3" className="box-col-4e">
      <div className="md-sidebar">
        <Btn color="primary" className="md-sidebar-toggle" onClick={()=>dispatch(setOpenFilter())}>{EmailFilter}</Btn>
        <div className={`md-sidebar-aside job-left-aside custom-scrollbar ${openFilter ?"open":""}`}>
          <div className="email-left-aside">
            <Card>
              <CardBody>
                <div className="email-app-sidebar">
                  <div className="d-flex">
                    <div className="media-size-email"><Image className="me-2 rounded-circle" src={dynamicImage("user/user.png")} alt="Image" /></div>
                    <div className="flex-grow-1"><H3 className="f-w-600">{MarkJenco} </H3><P>{MARKJENCOEMAIL}</P></div>
                  </div>
                  <Nav className="simple-list main-menu">
                    <NavItem>
                      <Link className="btn-primary btn-block btn-mail w-100" to={`${process.env.PUBLIC_URL}/email/email-compose`}>
                        <i className="icofont icofont-envelope me-2"></i> {NewMail}
                      </Link>
                    </NavItem>
                    <NavItem>
                      <Link className="show" to={`${process.env.PUBLIC_URL}/email/email-app`}>
                        <span className="title"><i className="icon-import"></i> {Inbox}</span>
                        <Badge color="tranparent" className="pull-right email-badge">(236)</Badge>
                      </Link>
                    </NavItem>
                    <DynamicEmailSideBar />
                  </Nav>
                </div>
              </CardBody>
            </Card>
          </div>
        </div>
      </div>
    </Col>
  );
};
